import { render } from "./component-kod-fs.vue?vue&type=template&id=7998a20e"
import script from "./component-kod-fs.vue?vue&type=script&setup=true&lang=js"
export * from "./component-kod-fs.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-kod-fs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7998a20e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7998a20e', __exports__)) {
    api.reload('7998a20e', __exports__)
  }
  
  module.hot.accept("./component-kod-fs.vue?vue&type=template&id=7998a20e", () => {
    api.rerender('7998a20e', render)
  })

}


export default __exports__